(() => {
  const initializeBrandMotion = () => {
    if (!document.querySelector('[data-bon-brand-homepage]')) return;
    document.body.classList.add('template-index');

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const sections = document.querySelectorAll('main > .shopify-section:not(:first-child)');

    if (reduceMotion || !('IntersectionObserver' in window)) {
      sections.forEach((section) => section.classList.add('bon-in-view'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('bon-in-view');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    sections.forEach((section) => {
      section.classList.add('bon-reveal-ready');
      observer.observe(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeBrandMotion, { once: true });
  } else {
    initializeBrandMotion();
  }
})();
